module.exports = __webpack_public_path__ + "img/artboard3.2a038843.png";